import * as yup from 'yup';

function effectiveDate(formatMessage) {
  return yup.string().required(
    formatMessage({
      id: 'EFFECTIVE_DATE_IS_REQUIRED',
      defaultMessage: 'Effective Date is required',
    }),
  );
}

const validationSchema = formatMessage =>
  yup
    .object({
      effectiveDate: effectiveDate(formatMessage),
    })
    .required();

export default validationSchema;
